<template>
    <div>
      <div class="row justify-content-center">
        <div class=" col-sm-6 grid-margin stretch-card">

    <div class="card">
      <div class="card-tile text-center p-2"><h2 class="">Update password</h2></div>
      <div class="card-body text-center">
        <div class="form-group mt-3">
                    <label class="form-label">Current Password</label>
                    <input type="password" v-model="message.current" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">New Password</label>
                    <input type="password" v-model="message.password" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Confirm Password</label>
                    <input type="password" v-model="message.repass" class="form-control" required>
                  </div>
                  <button type="button" class="btn btn-success" v-on:click="updatePassword()">Update Password</button>


      </div>
    </div>
    </div>
                          <div class=" col-sm-6 grid-margin stretch-card">

                            <div class="card">
                              <div class="card-tile text-center p-2"><h2 class="">Profile</h2></div>
                              <div class="card-body text-center">
                                <div class="brand-logo justify-content-center">
                  <img src="/assets/img/admin.png" style="width: 10%;">
                </div>
                <h2 class="text-center mt-3">{{ user.lname }} {{ user.fname }}</h2>
                <p><i class="mdi mdi-email menu-icon fa-2x mr-3"></i>  {{ user.email }}</p>
                <p><i class="mdi mdi-phone menu-icon fa-2x mr-3"></i>{{ user.phone }}</p>
                <p><i class="mdi mdi-calendar menu-icon fa-2x mr-3"></i>{{ filerDate(user.created_at) }}</p>
                <p><i class="mdi mdi-account menu-icon fa-2x mr-3"></i>{{ user.status }}</p>


                              </div>
                            </div>
                            </div>


                            </div>


    </div>
    </template>
    <script>
        import moment from 'moment'
        export default {
            name: 'App',
            components: {

            },
            data(){
                return {
                message:{},
                user:{}
                }
            },
            created(){
                  this.User();
            },
            methods: {
            updatePassword(){
                 this.$loading(true)
                   let uri =`/api/auth/updatePassword`;
                    this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                       if(response.data.status){
                       this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                       localStorage.removeItem('token');
                       localStorage.removeItem('auth');
                       this.$router.push({name: 'index'});
                       }else{
                        this.$swal({title: "Password",text: response.data.message,icon: "warning"});
                       }
                    }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
              },
                User(){

                    let uri =`/api/auth/user`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                       this.user=response.data;
                    }).catch(error => {
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
                },
                formatPrice(value) {
                    let val = (value/1).toFixed(2).replace('.', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                filerDate(date){
                    return moment(String(date)).format('MM/DD/YYYY HH:mm')
                }

            },
        }

    </script>
